
import React from 'react';
import { render } from 'react-dom'; // tells react that it's exporting html
import { Route, BrowserRouter, HashRouter, Switch } from 'react-router-dom';
import App from './App';
import '../node_modules/slick-carousel/slick/slick.css';
import '../node_modules/slick-carousel/slick/slick-theme.css';
import '../src/assets/css/bootstrap.min.css';
import '../src/assets/css/font-awesome.min.css';
import '../src/assets/css/ladda.min.css';
import '../src/assets/css/animate.css';
import '../src/assets/css/boardtrac-plus-app.css';
import './assets/css/carousel-transitions.css';

// import registerServiceWorker from './helpers/registerServiceWorker';

// require('es6-promise').polyfill();
window.Raven &&
window.Raven.config('https://1574f235e90049779ae608a8ad4d7407@sentry.io/254547', {autoBreadcrumbs: false}).install();


if (!window._babelPolyfill) {
    require('babel-polyfill');
}

// if (global._babelPolyfill) {
//     throw new Error('only one instance of babel-polyfill is allowed');
// }
// global._babelPolyfill = true;

let Router = BrowserRouter;

if (window.isElectron && window.isElectron()) {
    Router = HashRouter;
}

const router = (
    <Router>
        <Switch>
            <Route component={App} />
        </Switch>
    </Router>
);

render(router, document.getElementById('main'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js